



















import stringTableMixin from "@/mixins/stringTableMixin.js";
import VStringsBaseTable from "@/components/inventoryComponents/strings/layout/VStringsBaseTable.vue";
import Vue from "vue";

export default Vue.extend({
  name: "VStringsInputTable",
  components: { VStringsBaseTable },
  mixins: [stringTableMixin],
  props: {
    instrument: {
      type: String,
      required: true
    },
    strings: {
      type: Array,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleChange(id: string, value: number): void {
      this.$emit("change", { id, value });
    }
  }
});
